
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-cars/offers",
      function () {
        return require("private-next-pages/new-cars/offers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-cars/offers"])
      });
    }
  